import { WeatherEntityWithForecast, UseWeatherOptions } from "@hakit/core";

export function DummyComponentOptions(props: Partial<UseWeatherOptions>) {
  return props;
}

export function DummyComponent(props: Partial<WeatherEntityWithForecast>) {
  return props;
}
